// extracted by mini-css-extract-plugin
module.exports = {"staticContent":"static_staticContent__1FLlN","staticSection":"static_staticSection__3Z0IP"};